import React, { useState, useEffect, useRef } from "react";
import { CircularProgress } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FormLabel from "@material-ui/core/FormLabel";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import AddIcon from "@material-ui/icons/Add";
import { Controller, useForm, useFieldArray } from "react-hook-form";
import PlacesAutoComplete from "./PlacesAutoComplete";
import Link from "@material-ui/core/Link";
import * as virActions from "src/actions/virActions";
import * as appActions from "src/actions/appActions";
import { useIsMount } from "src/hooks/useIsMount";
import useStyles from "src/layouts/DigitalVIRLayout/useStyles";
import "react-phone-input-2/lib/style.css";
import "src/layouts/DigitalVIRLayout/CustomPhoneInput.css";
import { Button, RoundedButton } from "@packages/ui";
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import VirPhoneInput from "src/components/VirPhoneInput/VirPhoneInput";
import { getEmailValidation, renderError } from "src/utils/emailValidation";
import VirImageButton from "src/components/VirImageButton/VirImageButton";
import DiveButton from "src/components/DiveButton/DiveButton";
import brandColors from "@packages/ui/theme/colors";


const DigitalVIRThirdPartyDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const autoCompleteRef = useRef(null);
  //this is used by other additional thirdparties, if there are any
  const [places, setPlaces] = useState([]);
  const [autoCompleteRefs, setAutoCompleteRefs] = useState([]);
  const selectedVirid = useSelector((state) => state.vir?.athenaSelectedId?.selectedId);
  const athenaVirDetailPatchLoading = useSelector(
    (state) => state.vir.athenaVirDetailPatch?.loading
  );
  const athenaVirDetailPatchError = useSelector((state) => state.vir.athenaVirDetailPatch?.error);
  const athenaSource = useSelector((state) => state.vir.athenaSource.source);
  const athenaVirDetailPatch = useSelector((state) => state.vir.athenaVirDetailPatch?.data);
  const athenaVirDetail = useSelector((state) => state.vir.athenaVirDetail?.data);
  const resubmitFlag = useSelector((state) => state.vir?.athenaVirResubmit?.flag);
  const athenaRole = useSelector((state) => state.vir?.athenaRole?.role);
  const disableEdit = resubmitFlag && athenaRole !== "staff";
  const previousData = resubmitFlag ? athenaVirDetail : athenaVirDetailPatch;
  const [incidentAddress, setIncidentAddress] = useState(
    previousData.ThirdPartyDetail?.Address || ""
  );
  const [additionalAddresses, setAdditionalAddresses] = useState([
    previousData.AdditionalThirdPartyDetails
      ? previousData.AdditionalThirdPartyDetails[0]?.Address
      : "",
    previousData.AdditionalThirdPartyDetails
      ? previousData.AdditionalThirdPartyDetails[1]?.Address
      : "",
  ]);
  const [additionalPhones, setAdditionalPhones] = useState(["", ""]);
  const additionalThirdPartyDriverLiencesFlag = [
    Array.isArray(previousData?.AdditionalThirdPartyDetails) &&
      previousData.AdditionalThirdPartyDetails[0]?.DriverLicenceUploaded,
    Array.isArray(previousData?.AdditionalThirdPartyDetails) &&
      previousData.AdditionalThirdPartyDetails[1]?.DriverLicenceUploaded,
  ];
  const isMount = useIsMount();
  const [loading, setLoading] = useState(false);
  const brand = getBrandFromUrl().toLowerCase();
  const [driverLicence, setDriverLicence] = useState([
    previousData.ThirdPartyDetail?.DriverLicenceUploaded || false,
    additionalThirdPartyDriverLiencesFlag[0],
    additionalThirdPartyDriverLiencesFlag[1],
  ]);
  console.log("driverLicence", driverLicence)

  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    trigger,
    formState: { errors, isDirty },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      thirdParty: previousData.ThirdParty ? "yes" : "no",
      firstName: previousData.ThirdPartyDetail?.FirstName
        ? previousData.ThirdPartyDetail?.FirstName
        : "",
      lastName: previousData.ThirdPartyDetail?.LastName
        ? previousData.ThirdPartyDetail?.LastName
        : "",
      drivingLicenceNumber: previousData.ThirdPartyDetail?.DrivingLicence
        ? previousData.ThirdPartyDetail?.DrivingLicence
        : "",
      address: previousData.ThirdPartyDetail?.Address ? previousData.ThirdPartyDetail?.Address : "",
      drivingLicenceExpiryDate: previousData.ThirdPartyDetail?.DrivingLicenceExpiryDate
        ? previousData.ThirdPartyDetail?.DrivingLicenceExpiryDate
        : "",
      cellTelephoneNumber: previousData.ThirdPartyDetail?.Mobile
        ? previousData.ThirdPartyDetail?.Mobile
        : "",
      email: previousData.ThirdPartyDetail?.Email ? previousData.ThirdPartyDetail?.Email : "",
      vehicleRegistration: previousData.ThirdPartyDetail?.VehicleRegistration
        ? previousData.ThirdPartyDetail?.VehicleRegistration
        : "",
      vehicleMake: previousData.ThirdPartyDetail?.VehicleMake
        ? previousData.ThirdPartyDetail?.VehicleMake
        : "",
      vehicleModel: previousData.ThirdPartyDetail?.VehicleModel
        ? previousData.ThirdPartyDetail?.VehicleModel
        : "",
      insuranceCompanyName: previousData.ThirdPartyDetail?.InsuranceCompanyName
        ? previousData.ThirdPartyDetail?.InsuranceCompanyName
        : "",
      policy: previousData.ThirdPartyDetail?.Policy ? previousData.ThirdPartyDetail?.Policy : "",
      additionalThirdParty: previousData.AdditionalThirdPartyDetails
        ? previousData.AdditionalThirdPartyDetails.map((item) => ({
            firstName: item.FirstName || "",
            lastName: item.LastName || "",
            drivingLicenceNumber: item.DrivingLicence || "",
            address: item.Address || "",
            drivingLicenceExpiryDate: item.DrivingLicenceExpiryDate || "",
            cellTelephoneNumber: item.Mobile || "",
            email: item.Email || "",
            vehicleRegistration: item.VehicleRegistration || "",
            vehicleMake: item.VehicleMake || "",
            vehicleModel: item.VehicleModel || "",
            insuranceCompanyName: item.InsuranceCompanyName || "",
            policy: item.Policy || "",
          }))
        : [],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "additionalThirdParty",
  });
  useEffect(() => {
    if (!isMount) {
      if (!athenaVirDetailPatchLoading && loading) {
        setLoading(false);

        if (athenaVirDetailPatchError) {
          dispatch(
            appActions.createToast({
              type: "error",
              message: "Failed to update",
            })
          );
        } else {
          dispatch(
            virActions.detailVir({
              virId: selectedVirid,
            })
          );
          dispatch(
            appActions.createToast({
              type: "success",
              message: "Vehicle Incident Report is updated",
            })
          );

          navigate(`/vehicleincidents/witnessdetails?brand=${brand}`);
        }
      }
    }
  }, [athenaVirDetailPatchLoading]);

  // Watch form values for DiveButton
  const formFirstName = watch("firstName");
  const formLastName = watch("lastName");
  const formPhone = watch("cellTelephoneNumber");
  const formEmail = watch("email");

  // Watch additional third party fields for DiveButton
  const additionalThirdPartyValues = watch("additionalThirdParty");

  const handleDiveVerificationComplete = (success, driverIndex = 0) => {
    if (success) {
      const newDriverLicence = [...driverLicence];
      newDriverLicence[driverIndex] = true;
      setDriverLicence(newDriverLicence);
      dispatch(
        appActions.createToast({
          type: "success",
          message: "Driver license verification completed successfully",
        })
      );
    }
  };

  const addAnotherDriver = () => {
    if (fields.length >= 2) {
      return;
    }

    const newRef = React.createRef();
    setAutoCompleteRefs((prevRefs) => [...prevRefs, newRef]);
    setPlaces((prevPlaces) => [...prevPlaces, ""]);
    setAdditionalAddresses((prevAddresses) => [...prevAddresses, ""]);
    setAdditionalPhones((prevPhones) => [...prevPhones, ""]);
    append({
      firstName: "",
      lastName: "",
      drivingLicenceNumber: "",
      drivingLicenceExpiryDate: "",
      address: "",
      cellTelephoneNumber: "",
      email: "",
      vehicleRegistration: "",
      vehicleMake: "",
      vehicleModel: "",
      insuranceCompanyName: "",
      policy: "",
    });
  };
  const removeDriver = (index) => {
    remove(index);
    setPlaces((prevPlaces) => prevPlaces.filter((_, i) => i !== index));
    setAutoCompleteRefs((prevRefs) => prevRefs.filter((_, i) => i !== index));
    setAdditionalAddresses((prevAddresses) => prevAddresses.filter((_, i) => i !== index));
    setAdditionalPhones((prevPhones) => prevPhones.filter((_, i) => i !== index));
  };

  const handlePhoneChange = (phone, name, index) => {
    if (index === undefined) {
      setValue(name, phone);
    } else {
      const newPhones = [...additionalPhones];
      newPhones[index] = phone;
      setAdditionalPhones(newPhones);
      setValue(name, phone);
    }
  };
  const handleTextFieldChange = (event) => {
    const { name, value } = event.target;
    setValue(name, value);
  };
  const onSubmit = (data) => {
    setLoading(true);

    const virPayloadBE = {};
    const virPayloadTHERMEON = {};

    virPayloadTHERMEON["ThirdParty"] = "Y";
    virPayloadTHERMEON["ThirdParty1"] = {
      FirstName: data.firstName,
      LastName: data.lastName,
      DrivingLicenceNumber: data.drivingLicenceNumber,
      DrivingLicenceExpiryDate: data.drivingLicenceExpiryDate,
      Address: data.address || incidentAddress,
      CellTelephoneNumber: data.cellTelephoneNumber,
      Email: data.email,
      ThirdPartyVehicleLicense: data.vehicleRegistration,
      ThirdPartyDescription: data.vehicleMake + " " + data.vehicleModel,
      ThirdPartyInsurance: data.insuranceCompanyName,
    };

    virPayloadBE["Policy"] = data.policy;
    virPayloadBE["Make"] = data.vehicleMake;
    virPayloadBE["Model"] = data.vehicleModel;

    if (places.length > 0) {
      const thermeonData = data.additionalThirdParty.map((e, index) => {
        return {
          FirstName: e.firstName,
          LastName: e.lastName,
          DrivingLicenceNumber: e.drivingLicenceNumber,
          DrivingLicenceExpiryDate: e.drivingLicenceExpiryDate,
          Address: e.address,
          CellTelephoneNumber: e.cellTelephoneNumber,
          Email: e.email,
        };
      });

      const BEData = data.additionalThirdParty.map((e) => {
        return {
          ThirdPartyVehicleLicense: e.vehicleRegistration,
          VehicleMake: e.vehicleMake,
          VehicleModel: e.vehicleModel,
          ThirdPartyInsurance: e.insuranceCompanyName,
          Policy: e.policy,
        };
      });

      virPayloadTHERMEON["AdditionalThirdParty"] = thermeonData;
      virPayloadBE["AdditionalThirdParty"] = BEData;
    }
    // Constructing the Additional Third Party Details array
    let additionalThirdPartyDetails = [];

    if (data.additionalThirdParty && data.additionalThirdParty.length > 0) {
      additionalThirdPartyDetails = data.additionalThirdParty.map((thirdParty, index) => ({
        FirstName: thirdParty.firstName,
        LastName: thirdParty.lastName,
        DrivingLicence: thirdParty.drivingLicenceNumber,
        DrivingLicenceExpiryDate: thirdParty.drivingLicenceExpiryDate,
        Address: thirdParty.address,
        Mobile: thirdParty.cellTelephoneNumber,
        Email: thirdParty.email,
        VehicleRegistration: thirdParty.vehicleRegistration,
        VehicleMake: thirdParty.vehicleMake,
        VehicleModel: thirdParty.vehicleModel,
        InsuranceCompanyName: thirdParty.insuranceCompanyName,
        Policy: thirdParty.policy,
        DriverLicenceUploaded: driverLicence[index + 1],
      }));
    }
    const params = {
      virId: selectedVirid,
      virStatus: resubmitFlag ? "SubmissionPage" : "ThirdPartyDetail",
      data:
        data.thirdParty === "yes"
          ? {
              ThirdPartyDetail: {
                FirstName: data.firstName,
                LastName: data.lastName,
                DrivingLicence: data.drivingLicenceNumber,
                DrivingLicenceExpiryDate: data.drivingLicenceExpiryDate,
                Address: data.address || incidentAddress,
                Mobile: data.cellTelephoneNumber,
                Email: data.email,
                VehicleRegistration: data.vehicleRegistration,
                VehicleMake: data.vehicleMake,
                VehicleModel: data.vehicleModel,
                InsuranceCompanyName: data.insuranceCompanyName,
                Policy: data.policy,
                DriverLicenceUploaded: driverLicence[0],
              },
              ThirdParty: true,
              AdditionalThirdPartyDetails:
                additionalThirdPartyDetails.length > 0 ? additionalThirdPartyDetails : undefined,
            }
          : { ThirdParty: false },
    };
    if (athenaSource === "sms" && isDirty) {
      params.data.CustomerEditBySms = true;
    }
    dispatch(virActions.detailPatchVir(params));
  };
  const handleAddressChange = (address, name, index) => {
    if (index === undefined) {
      setValue(name, address);
    } else {
      const newAddresses = [...additionalAddresses];
      newAddresses[index] = address;
      setAdditionalAddresses(newAddresses);
      setValue(name, address);
    }
  };
  return (
    <>
      <Box>
        <h2 className={classes.heading}>
          Please provide details of any other drivers and vehicles involved in the incident.
        </h2>
        <br></br>
      </Box>
      <hr className={classes.breakLine} style={{ borderColor: brandColors[brand] }} />
      <Box
        sx={{
          p: 4,
          pb: 10,
          fontFamily: "Ride",
          color: "#333",
          maxWidth: "500px",
          margin: "0 auto",
          zIndex: 1000,
          backgroundColor: "#fff",
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <FormControl component="fieldset">
            <FormLabel component="legend" className={classes.radioFormat}>
              Were there any other vehicles involved?
            </FormLabel>

            <Controller
              rules={{ required: true }}
              control={control}
              name="thirdParty"
              render={({ field }) => (
                <RadioGroup row {...field}>
                  <FormControlLabel
                    value="yes"
                    disabled={disableEdit && previousData?.ThirdParty}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="no"
                    disabled={disableEdit && previousData?.ThirdParty}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              )}
            />

            {watch("thirdParty") == "yes" && (
              <>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Controller
                      control={control}
                      rules={{ required: "First Name is required" }}
                      name="firstName"
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          inputProps={{
                            autoComplete: "new-password",
                          }}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                          multiline
                          maxRows={1}
                          id="firstName"
                          name="firstName"
                          label="First Name"
                          placeholder="Enter First Name"
                          value={value}
                          error={errors.firstName ? true : false}
                          onChange={handleTextFieldChange}
                          helperText={errors.firstName?.message}
                          disabled={
                            disableEdit &&
                            previousData?.ThirdPartyDetail?.FirstName != undefined &&
                            previousData?.ThirdPartyDetail?.FirstName != ""
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      control={control}
                      rules={{ required: "Last Name is required" }}
                      name="lastName"
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          inputProps={{
                            autoComplete: "new-password",
                          }}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                          multiline
                          maxRows={1}
                          id="lastName"
                          name="lastName"
                          label="Last Name"
                          placeholder="Enter Last Name"
                          value={value}
                          error={errors.lastName ? true : false}
                          onChange={handleTextFieldChange}
                          helperText={errors.lastName?.message}
                          disabled={
                            disableEdit &&
                            previousData?.ThirdPartyDetail?.LastName != undefined &&
                            previousData?.ThirdPartyDetail?.LastName !== ""
                          }
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <DiveButton
                    disabled={driverLicence[0]}
                    firstName={formFirstName || ""}
                    lastName={formLastName || ""}
                    phone={formPhone || ""}
                    email={formEmail || ""}
                    virId={selectedVirid}
                    brand={brand}
                    onVerificationComplete={(success) => handleDiveVerificationComplete(success, 0)}
                    endpointName={"thirdParty"}
                    onClickValidate={async () => {
                      return await trigger(["firstName", "lastName"]);
                    }}
                    title={
                      driverLicence[0]
                        ? "Other driver's license is uploaded"
                        : "Upload Other driver's license"
                    }
                  />
                </Grid>
                <Grid container>
                  <Grid item xs={12}>
                    <TextField
                      label="Driver Licence #"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      {...register("drivingLicenceNumber")}
                      disabled={
                        disableEdit &&
                        previousData?.ThirdPartyDetail?.DrivingLicence != undefined &&
                        previousData?.ThirdPartyDetail?.DrivingLicence !== ""
                      }
                    />
                    <TextField
                      label="Drivers Licence Expiry"
                      variant="outlined"
                      fullWidth
                      type="date"
                      margin="normal"
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      {...register("drivingLicenceExpiryDate", {})}
                      error={!!errors.drivingLicenceExpiryDate}
                      helperText={errors.drivingLicenceExpiryDate?.message}
                      disabled={
                        disableEdit &&
                        previousData?.ThirdPartyDetail?.DrivingLicenceExpiryDate != undefined &&
                        previousData?.ThirdPartyDetail?.DrivingLicenceExpiryDate !== ""
                      }
                    />
                    <Box sx={{ mt: 1 }}>
                      <PlacesAutoComplete
                        onAddressChange={(address) => handleAddressChange(address, "address")}
                        ref={autoCompleteRef}
                        incidentAddress={incidentAddress}
                        label="Home Address"
                        disabled={
                          disableEdit &&
                          previousData?.ThirdPartyDetail?.Address != undefined &&
                          previousData?.ThirdPartyDetail?.Address !== ""
                        }
                        page="thirdParty"
                      />
                    </Box>
                    <Grid item xs={12}>
                      <Box sx={{ mt: 2 }}>
                        <Grid item xs={12}>
                          <Box sx={{ mt: 2, mb: 2 }}>
                            <Controller
                              control={control}
                              name="cellTelephoneNumber"
                              className={classes.flexContainer}
                              render={({ field: { value, onChange } }) => (
                                <VirPhoneInput
                                  phoneNumber={value}
                                  onChange={(phone) =>
                                    handlePhoneChange(phone, "cellTelephoneNumber")
                                  }
                                  disabled={
                                    disableEdit &&
                                    previousData?.ThirdPartyDetail?.Mobile !== "" &&
                                    previousData?.ThirdPartyDetail?.Mobile !== undefined
                                  }
                                />
                              )}
                            />
                          </Box>
                        </Grid>
                      </Box>
                    </Grid>
                    <TextField
                      label="Email Address"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      {...register("email", getEmailValidation())}
                      disabled={
                        disableEdit &&
                        previousData?.ThirdPartyDetail?.Email != undefined &&
                        previousData?.ThirdPartyDetail?.Email !== ""
                      }
                    />
                    {renderError(errors, "email")}
                    <TextField
                      label="Vehicle Registration"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      {...register("vehicleRegistration")}
                      disabled={
                        disableEdit &&
                        previousData?.ThirdPartyDetail?.VehicleRegistration != undefined &&
                        previousData?.ThirdPartyDetail?.VehicleRegistration != ""
                      }
                    />
                    <Box sx={{ mt: 2 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <TextField
                            label="Vehicle Make"
                            variant="outlined"
                            fullWidth
                            {...register("vehicleMake")}
                            disabled={
                              disableEdit &&
                              previousData?.ThirdPartyDetail?.VehicleMake != undefined &&
                              previousData?.ThirdPartyDetail?.VehicleMake != ""
                            }
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="Vehicle Model"
                            variant="outlined"
                            fullWidth
                            {...register("vehicleModel")}
                            disabled={
                              disableEdit &&
                              previousData?.ThirdPartyDetail?.VehicleModel != undefined &&
                              previousData?.ThirdPartyDetail?.VehicleModel != ""
                            }
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <TextField
                      label="Insurance Company Name"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      {...register("insuranceCompanyName")}
                      disabled={
                        disableEdit &&
                        previousData?.ThirdPartyDetail?.InsuranceCompanyName != undefined &&
                        previousData?.ThirdPartyDetail?.InsuranceCompanyName != ""
                      }
                    />
                    <TextField
                      label="Policy #"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      {...register("policy")}
                      disabled={
                        disableEdit &&
                        previousData?.ThirdPartyDetail?.Policy != undefined &&
                        previousData?.ThirdPartyDetail?.Policy !== ""
                      }
                    />
                  </Grid>

                  <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                    {fields.map((item, index) => {
                      return (
                        <li key={item.id}>
                          <Box mb={3}>
                            <FormLabel>Additional Third Party {index + 1}</FormLabel>
                          </Box>
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <TextField
                                label="First Name"
                                variant="outlined"
                                fullWidth
                                error={!!errors?.additionalThirdParty?.[index]?.firstName}
                                helperText={errors?.additionalThirdParty?.[index]?.firstName?.message}
                                {...register(`additionalThirdParty.${index}.firstName`, {
                                  required: "First Name is required",
                                })}
                                disabled={
                                  disableEdit &&
                                  previousData.AdditionalThirdPartyDetails !== undefined &&
                                  previousData.AdditionalThirdPartyDetails[index]?.FirstName !=
                                    undefined &&
                                  previousData.AdditionalThirdPartyDetails[index]?.FirstName != ""
                                }
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                label="Last Name"
                                variant="outlined"
                                fullWidth
                                error={!!errors?.additionalThirdParty?.[index]?.lastName}
                                helperText={errors?.additionalThirdParty?.[index]?.lastName?.message}
                                {...register(`additionalThirdParty.${index}.lastName`, {
                                  required: "Last Name is required",
                                })}
                                disabled={
                                  disableEdit &&
                                  previousData.AdditionalThirdPartyDetails !== undefined &&
                                  previousData.AdditionalThirdPartyDetails[index]?.LastName !=
                                    undefined &&
                                  previousData.AdditionalThirdPartyDetails[index]?.LastName != ""
                                }
                              />
                            </Grid>
                          <Grid item xs={12}>
                            <DiveButton
                              disabled={driverLicence[index + 1]}
                              firstName={additionalThirdPartyValues?.[index]?.firstName || ""}
                              lastName={additionalThirdPartyValues?.[index]?.lastName || ""}
                              phone={additionalThirdPartyValues?.[index]?.cellTelephoneNumber || ""}
                              email={additionalThirdPartyValues?.[index]?.email || ""}
                              virId={selectedVirid}
                              brand={brand}
                              onVerificationComplete={(success) => handleDiveVerificationComplete(success, index + 1)}
                              endpointName={`thirdParty${index + 1}`}
                              onClickValidate={async () => {
                                return await trigger([
                                  `additionalThirdParty.${index}.firstName`,
                                  `additionalThirdParty.${index}.lastName`,
                                ]);
                              }}
                              title={
                                driverLicence[index + 1]
                                  ? "Additional driver's license is uploaded"
                                  : "Upload Additional driver's license"
                              }
                            />
                          </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              label="Driver Licence #"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              {...register(`additionalThirdParty.${index}.drivingLicenceNumber`)}
                              disabled={
                                disableEdit &&
                                previousData.AdditionalThirdPartyDetails !== undefined &&
                                previousData.AdditionalThirdPartyDetails[index]?.DrivingLicence !=
                                  undefined &&
                                previousData.AdditionalThirdPartyDetails[index]?.DrivingLicence !=
                                  ""
                              }
                            />
                            <TextField
                              label="Drivers Licence Expiry"
                              variant="outlined"
                              fullWidth
                              type="date"
                              margin="normal"
                              className={classes.textField}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...register(
                                `additionalThirdParty.${index}.drivingLicenceExpiryDate`
                              )}
                              error={!!errors.drivingLicenceExpiryDate}
                              helperText={errors.drivingLicenceExpiryDate?.message}
                              disabled={
                                disableEdit &&
                                previousData.AdditionalThirdPartyDetails !== undefined &&
                                previousData.AdditionalThirdPartyDetails[index]
                                  ?.DrivingLicenceExpiryDate !== undefined &&
                                previousData.AdditionalThirdPartyDetails[index]
                                  ?.DrivingLicenceExpiryDate !== ""
                              }
                            />

                            <Box sx={{ mt: 1 }}>
                              <PlacesAutoComplete
                                onAddressChange={(address) => {
                                  handleAddressChange(
                                    address,
                                    `additionalThirdParty.${index}.address`,
                                    index
                                  );
                                }}
                                ref={autoCompleteRefs[index]}
                                incidentAddress={additionalAddresses[index]}
                                label={`Home Address ${index + 1}`}
                                disabled={
                                  disableEdit &&
                                  previousData.AdditionalThirdPartyDetails !== undefined &&
                                  previousData?.AdditionalThirdPartyDetails[index]?.Address !==
                                    undefined &&
                                  previousData?.AdditionalThirdPartyDetails[index]?.Address !== ""
                                }
                                {...register(`additionalThirdParty.${index}.address`)}
                                // {...register()}
                              />
                            </Box>
                            <Grid item xs={12}>
                              <Box sx={{ mt: 2 }}>
                                <Grid item xs={12}>
                                  <Box sx={{ mt: 2, mb: 2 }}>
                                    <Controller
                                      control={control}
                                      name={`additionalThirdParty.${index}.cellTelephoneNumber`}
                                      className={classes.flexContainer}
                                      render={({ field: { value, onChange } }) => (
                                        <VirPhoneInput
                                          phoneNumber={value}
                                          onChange={(phone) =>
                                            handlePhoneChange(
                                              phone,
                                              `additionalThirdParty.${index}.cellTelephoneNumber`
                                            )
                                          }
                                          disabled={
                                            disableEdit &&
                                            previousData.AdditionalThirdPartyDetails !==
                                              undefined &&
                                            previousData?.AdditionalThirdPartyDetails[index]
                                              ?.Mobile !== undefined &&
                                            previousData?.AdditionalThirdPartyDetails[index]
                                              ?.Mobile !== ""
                                          }
                                        />
                                      )}
                                    />
                                  </Box>
                                </Grid>
                              </Box>
                            </Grid>
                            <TextField
                              label="Email Address"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              {...register(
                                `additionalThirdParty.${index}.email`,
                                getEmailValidation()
                              )}
                              disabled={
                                disableEdit &&
                                previousData.AdditionalThirdPartyDetails !== undefined &&
                                previousData?.AdditionalThirdPartyDetails[index]?.Email !=
                                  undefined &&
                                previousData?.AdditionalThirdPartyDetails[index]?.Email != ""
                              }
                            />
                            {renderError(errors, `additionalThirdParty.${index}.email`)}
                            <TextField
                              label="Vehicle Registration"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              {...register(`additionalThirdParty.${index}.vehicleRegistration`)}
                              disabled={
                                disableEdit &&
                                previousData.AdditionalThirdPartyDetails !== undefined &&
                                previousData?.AdditionalThirdPartyDetails[index]
                                  ?.VehicleRegistration !== undefined &&
                                previousData?.AdditionalThirdPartyDetails[index]
                                  ?.VehicleRegistration !== ""
                              }
                            />
                            <Box sx={{ mt: 2 }}>
                              <Grid container spacing={2}>
                                <Grid item xs={6}>
                                  <TextField
                                    label="Vehicle Make"
                                    variant="outlined"
                                    fullWidth
                                    {...register(`additionalThirdParty.${index}.vehicleMake`)}
                                    disabled={
                                      disableEdit &&
                                      previousData.AdditionalThirdPartyDetails !== undefined &&
                                      previousData?.AdditionalThirdPartyDetails[index]
                                        ?.VehicleMake !== undefined &&
                                      previousData?.AdditionalThirdPartyDetails[index]
                                        ?.VehicleMake !== ""
                                    }
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField
                                    label="Vehicle Model"
                                    variant="outlined"
                                    fullWidth
                                    {...register(`additionalThirdParty.${index}.vehicleModel`)}
                                    disabled={
                                      disableEdit &&
                                      previousData.AdditionalThirdPartyDetails !== undefined &&
                                      previousData?.AdditionalThirdPartyDetails[index]
                                        ?.VehicleModel !== undefined &&
                                      previousData?.AdditionalThirdPartyDetails[index]
                                        ?.VehicleModel !== ""
                                    }
                                  />
                                </Grid>
                              </Grid>
                            </Box>
                            <TextField
                              label="Insurance Company Name"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              {...register(`additionalThirdParty.${index}.insuranceCompanyName`)}
                              disabled={
                                disableEdit &&
                                previousData.AdditionalThirdPartyDetails !== undefined &&
                                previousData?.AdditionalThirdPartyDetails[index]
                                  ?.InsuranceCompanyName !== undefined &&
                                previousData?.AdditionalThirdPartyDetails[index]
                                  ?.InsuranceCompanyName !== ""
                              }
                            />
                            <TextField
                              label="Policy #"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              {...register(`additionalThirdParty.${index}.policy`)}
                              disabled={
                                disableEdit &&
                                previousData.AdditionalThirdPartyDetails !== undefined &&
                                previousData?.AdditionalThirdPartyDetails[index]?.Policy !==
                                  undefined &&
                                previousData?.AdditionalThirdPartyDetails[index]?.Policy !== ""
                              }
                            />
                          </Grid>
                          <div className={classes.button}>
                            {fields.length <= 2 && (
                              <Button
                                variant="contained"
                                fullWidth
                                onClick={() => removeDriver(index)}
                              >
                                Remove additional thridy party {index + 1}
                              </Button>
                            )}
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                  {fields.length <= 1 && (
                    <Link
                      onClick={addAnotherDriver}
                      underline="hover"
                      color="inherit"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                    >
                      <Grid item xs={2}>
                        <IconButton size="small" edge="start">
                          <AddIcon />
                        </IconButton>
                      </Grid>
                      <Grid item xs={10}>
                        <Typography color="primary">Add another driver</Typography>
                      </Grid>
                    </Link>
                  )}
                </Grid>
              </>
            )}
          </FormControl>

          <Box sx={{ my: 3 }}>
            <RoundedButton
              variant="contained"
              fullWidth
              sx={{ mt: 2, width: "80%", margin: "2" }}
              type="submit"
              disabled={loading}
            >
              {loading ? <CircularProgress /> : "Continue"}
            </RoundedButton>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default DigitalVIRThirdPartyDetails;
